import React from 'react'
import T from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Box } from '@mui/material'

import Tooltip from 'components/atoms/Tooltip'
import CarCardAdditionalDetails from 'components/atoms/CarCardAdditionalDetails'
import CarCardAdditionalDetailsItem from 'components/atoms/CarCardAdditionalDetailsItem'

import {
  getCarsBookedChoiceKey,
  getCarsBookedDisplayStatus,
  getCarsBookedStatusColor,
} from './carsBookedLib'

export default function CarBookedCarAdditionalDetails({
  vertical,
  car,
  canReprice,
}) {
  const { t } = useTranslation()

  const numberFormatter = new Intl.NumberFormat('it-IT')
  const displayStatus = getCarsBookedDisplayStatus(car)

  return (
    <CarCardAdditionalDetails
      vertical={vertical}
      data-testid="car-booked-additional-details"
    >
      {!vertical && (
        <CarCardAdditionalDetailsItem
          vertical={vertical}
          title={t('carsBooked.additionalTitles.status')}
          value={t(`carsBooked.status.${displayStatus}`)}
          valueProps={{
            color: getCarsBookedStatusColor(car),
          }}
        />
      )}
      <CarCardAdditionalDetailsItem
        vertical={vertical}
        title={t('carsBooked.additionalTitles.choice')}
        value={t(`carsBooked.${getCarsBookedChoiceKey(car)}`)}
      />
      {canReprice && (
        <CarCardAdditionalDetailsItem
          vertical={vertical}
          title={t('carsBooked.additionalTitles.reprice')}
          value={
            (car.reprice &&
              `${vertical ? '€ ' : ''}${numberFormatter.format(
                car.reprice
              )}`) ||
            '-'
          }
        />
      )}
      {vertical && <Box p={1} />}
      {vertical && (
        <CarCardAdditionalDetailsItem
          vertical={vertical}
          title={t('carsBooked.additionalTitles.status')}
          value={t(`carsBooked.status.${displayStatus}`)}
          valueProps={{
            color: getCarsBookedStatusColor(car),
          }}
        />
      )}

      {vertical && <Box p={1} />}
      {car?.publicAdvice && vertical && (
        <CarCardAdditionalDetailsItem
          vertical={vertical}
          title={'Avviso'}
          value={
            <div
              style={{
                maxWidth: 290,
                whiteSpace: 'break-spaces',
                textAlign: 'right',
              }}
            >
              {car.publicAdvice}
            </div>
          }
          valueProps={{
            color: 'error',
          }}
        />
      )}
      {car?.publicAdvice && !vertical && (
        <CarCardAdditionalDetailsItem
          vertical={vertical}
          title={'Avviso'}
          value={
            <Tooltip title={car.publicAdvice} placement="top-end">
              <div
                style={{
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis',
                }}
              >
                {car.publicAdvice}
              </div>
            </Tooltip>
          }
          valueProps={{
            color: 'error',
          }}
          stackProps={{
            width: 0,
            flex: 1,
          }}
        />
      )}
    </CarCardAdditionalDetails>
  )
}

CarBookedCarAdditionalDetails.propTypes = {
  vertical: T.bool,
  car: T.object.isRequired,
  canReprice: T.bool,
}
